import { Breadcrumb, Empty, notification } from "antd";
import { Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddCapabilityButton from "./AddCapabilityButton";
import CapabilityCard from "./CapabilityCard";
import Grid from "@material-ui/core/Grid";
import { fetchCapabilities } from "../../../redux/Capabilities/actions";

const { Search } = Input;

export const Capabilities = () => {
    const dispatch = useDispatch();
    const { capabilities, error } = useSelector((state) => state.capabilities || {});
    const [capabilitysearch, setCapabilitysearch] = useState([]);
    const [search_Mode, setSearch_Mode] = useState(false);

    useEffect(() => {
        dispatch(fetchCapabilities());
    }, [dispatch]);

    useEffect(() => {
        if (!search_Mode) {
            setCapabilitysearch(capabilities);
        }
    }, [capabilities, search_Mode]);

    useEffect(() => {
        if (error) {
            notification.error({
                message: 'Error',
                description: error,
            });
        }
    }, [error]);

    const capabilitySearch_Fun = (value) => {
        if (value.length > 0) {
            setSearch_Mode(true);
            const filteredCapabilities = capabilities.filter((el) => el.name.includes(value));
            setCapabilitysearch(filteredCapabilities);
        } else {
            setSearch_Mode(false);
            setCapabilitysearch([]);
        }
    };

    return (
        <div>
            <Breadcrumb style={{ margin: "16px 0px" }}>
                <Breadcrumb.Item>Capabilities</Breadcrumb.Item>
                <div style={{ float: "right", marginTop: 20 }}>
                    <Grid container>
                        <Grid item>
                            <Grid container justify="center"></Grid>
                            <Search
                                placeholder="Search"
                                onChange={(e) => {
                                    if (e.target.value.length === 0) setSearch_Mode(false);
                                }}
                                style={{ minWidth: 150, maxWidth: 220 }}
                                enterButton
                                onSearch={capabilitySearch_Fun}
                            />
                            <AddCapabilityButton />
                        </Grid>
                    </Grid>
                </div>
            </Breadcrumb>
            <br />
            <br />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={2}>
                        {search_Mode ? (
                            capabilitysearch.length === 0 ? (
                                <Empty />
                            ) : (
                                capabilitysearch.map((item, index) => {
                                    return (
                                        <Grid key={index} item>
                                            <CapabilityCard item={item} />
                                        </Grid>
                                    );
                                })
                            )
                        ) : (
                            capabilities.map((item, index) => {
                                return (
                                    <Grid key={index} item>
                                        <CapabilityCard item={item} />
                                    </Grid>
                                );
                            })
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default Capabilities;
